import { graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import React from "react";

import Quote from "../components/Quote";

const QuoteParagraph = ({ content, title }) => (
  <Quote
    title={title}
    author={content.author ? content.author.processed : ""}
    authorsub={content.credentials ? content.credentials.processed : ""}
    image={getImage(content.r.img.r.img.localFile)}
    imageLarge={getImage(content.r.img.r.img.localFile)}
    alt={content.r.img.img.alt}
  >
    {content.quote ? content.quote.value : ""}
  </Quote>
);

export const query = graphql`
  fragment ParagraphQuote on paragraph__quote {
    type: __typename
    author: field_quote_author {
      processed
    }
    credentials: field_quote_credentials {
      processed
    }
    quote: field_quote_text {
      value
    }
    r: relationships {
      img: field_quote_image {
        img: field_image {
          alt
        }
        r: relationships {
          img: field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH)
              }
            }
          }
        }
      }
    }
  }
`;

export default QuoteParagraph;
